import { Box, IconButton, Stack, useTheme } from "@mui/material";
import { CartButton } from "./cart-button.js";
import { LocalizationContext } from "../localization/index.js";
import { Logo } from "../logo/index.js";
import { Menu } from "@mui/icons-material";
import { MobileMenu } from "./mobile-menu.js";
import { MobileStickyHeader } from "./mobile-sticky.js";
import { Portal } from "../portal.js";
import { useContrastColor } from "../utilities/index.js";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
export const MobileHeader = ({ bgColor = "white", color, items = [] }) => {
    const { mode } = React.useContext(LocalizationContext);
    const { t } = useTranslation("c-common");
    const theme = useTheme();
    const contrastColor = useContrastColor(bgColor);
    const textColor = color ?? contrastColor;
    const [showNavigation, setShowNavigation] = React.useState(false);
    const toggleNavigation = () => setShowNavigation((current) => !current);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { className: "mobile-header-container", component: "header", sx: {
                backgroundColor: "transparent",
                color: textColor,
                height: { xs: "125px", sm: "135px" },
                position: "relative",
                width: "100%",
                zIndex: 30,
            } },
            React.createElement(Stack, { alignItems: "flex-start", direction: "row", justifyContent: "space-between", sx: {
                    pb: 0,
                    pt: { xs: 2, sm: 3 },
                    px: { xs: `calc(${theme.spacing(3)} - 5px)`, sm: `calc(${theme.spacing(4)} - 5px)` },
                    width: "100%",
                } },
                React.createElement(Box, { sx: { width: "45px" } }, mode === "store" && React.createElement(CartButton, { color: textColor, size: "small" })),
                React.createElement(Box, { id: "mobile-logo", sx: { mt: -1, width: { xs: "72px", sm: "82px" } } },
                    React.createElement(Link, { "aria-label": t("front-page", "Startseite"), href: "/", title: t("seo-site-title") },
                        React.createElement(Logo, { fill: textColor, variant: "vertical", title: t("seo-site-title") }))),
                React.createElement(Box, { sx: { width: "45px" } },
                    React.createElement(IconButton, { name: t("open-main-menu", "Hauptmenü öffnen"), "aria-label": t("open-main-menu", "Hauptmenü öffnen"), onClick: toggleNavigation, sx: { color: textColor }, size: "small" },
                        React.createElement(Menu, { fontSize: "small" }))))),
        React.createElement(Portal, { nodeId: "fullscreen-menu" },
            React.createElement(MobileMenu, { handleClose: toggleNavigation, items: items, show: showNavigation })),
        React.createElement(Portal, { nodeId: "mobile-sticky-header" },
            React.createElement(MobileStickyHeader, { items: items }))));
};
//# sourceMappingURL=mobile-header.js.map